import { j as a } from "./jsx-runtime-DywqP_6a.js";
import * as e from "@radix-ui/react-dialog";
import { CircleIcon as c, XIcon as p } from "lucide-react";
import * as l from "react";
import { c as r } from "./cn-dYga0KKN.js";
const b = e.Root, j = e.Trigger, m = e.Portal, v = e.Close, i = l.forwardRef(({ className: t, ...o }, s) => /* @__PURE__ */ a.jsx(
  e.Overlay,
  {
    ref: s,
    className: r(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      t
    ),
    ...o
  }
));
i.displayName = e.Overlay.displayName;
const f = l.forwardRef(({ className: t, children: o, showCloseButton: s = !0, ...n }, d) => /* @__PURE__ */ a.jsxs(m, { children: [
  /* @__PURE__ */ a.jsx(i, {}),
  /* @__PURE__ */ a.jsxs(
    e.Content,
    {
      ref: d,
      className: r(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        t
      ),
      ...n,
      children: [
        o,
        s && /* @__PURE__ */ a.jsxs(e.Close, { className: "absolute p-3 group -left-1.5 -top-1.5 rounded-xs opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ a.jsx(
            c,
            {
              className: "h-2 w-2 transition-all border border-transparent  group-hover:border-white/20 rounded-full group-hover:scale-180 group-hover:text-red-400",
              strokeWidth: 2,
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ a.jsx(
            p,
            {
              className: "h-2 w-2 absolute top-3 left-3 text-transparent group-hover:text-red-800 transition-colors",
              strokeWidth: 2,
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ a.jsx("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
f.displayName = e.Content.displayName;
const g = ({
  className: t,
  ...o
}) => /* @__PURE__ */ a.jsx(
  "div",
  {
    className: r(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      t
    ),
    ...o
  }
);
g.displayName = "DialogHeader";
const u = ({
  className: t,
  ...o
}) => /* @__PURE__ */ a.jsx(
  "div",
  {
    className: r(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      t
    ),
    ...o
  }
);
u.displayName = "DialogFooter";
const x = l.forwardRef(({ className: t, ...o }, s) => /* @__PURE__ */ a.jsx(
  e.Title,
  {
    ref: s,
    className: r(
      "text-lg font-semibold leading-none tracking-tight",
      t
    ),
    ...o
  }
));
x.displayName = e.Title.displayName;
const y = l.forwardRef(({ className: t, ...o }, s) => /* @__PURE__ */ a.jsx(
  e.Description,
  {
    ref: s,
    className: r("text-sm text-muted-foreground", t),
    ...o
  }
));
y.displayName = e.Description.displayName;
export {
  b as D,
  f as a,
  g as b,
  x as c,
  y as d,
  u as e,
  v as f,
  j as g
};
//# sourceMappingURL=Dialog-VIMic7xI.js.map
